import type { BackToSchoolAudience } from '../types/backToSchoolAudience'

export const isFreeAudience = (audience: BackToSchoolAudience) => audience === 'free'
